import { createContext, useContext } from 'react'

export interface CallsContextValue {
  /** Whether calls can be made (module on, LiveKit set up on the server). */
  available: boolean
  /** The call this browser is in. */
  activeCallId: number | null
  start: (conversationId: number, video: boolean, title: string, direct: boolean) => Promise<void>
  join: (callId: number, title: string, video: boolean, direct: boolean) => Promise<void>
}

export const CallsContext = createContext<CallsContextValue>({
  available: false,
  activeCallId: null,
  start: () => Promise.resolve(),
  join: () => Promise.resolve(),
})

export function useCalls(): CallsContextValue {
  return useContext(CallsContext)
}
